"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _createStyles = require("../styles/createStyles");
const _excluded = ["className", "orientation"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = exports.useStyles = (0, _createStyles.createStyles)(_ref => {
  let {
    theme
  } = _ref;
  const {
    spacing
  } = theme.busbud;
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: spacing(5),
      height: spacing(5)
    },
    top: {
      transform: 'rotate(90deg)'
    },
    left: {}
  };
});

/**
 * Display a SteeringWheel for displaying the place of the driver on a bus.
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-inputs-steeringwheel--page)
 */
const SteeringWheel = /*#__PURE__*/React.forwardRef(function SeatBase(props, ref) {
  const {
      className,
      orientation = 'top'
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes,
    cx
  } = useStyles();
  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
    className: cx(classes.root, classes[orientation], className),
    ref: ref
  }, other), /*#__PURE__*/React.createElement("svg", {
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8162_76654)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: "0.1",
    d: "M16 4.12904C16.692 4.12864 17.3828 4.18822 18.0645 4.30711V10.8387L22.1935 13.9355H27.6929C27.9303 15.3016 27.9303 16.6984 27.6929 18.0645H22.1935L18.0645 21.1613V27.6929C16.6984 27.9303 15.3016 27.9303 13.9355 27.6929V21.62C13.3095 21.2608 12.7891 20.7431 12.4267 20.1189C12.0643 19.4948 11.8726 18.7862 11.871 18.0645V13.9355C11.8726 13.2137 12.0643 12.505 12.4267 11.8808C12.7891 11.2565 13.3095 10.7387 13.9355 10.3794V4.30775C14.6172 4.18864 15.308 4.12885 16 4.12904Z",
    fill: "#698CA5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: "0.2",
    d: "M4.12903 16C4.1291 13.2536 5.08145 10.5922 6.8238 8.46922C8.56616 6.34626 10.9907 4.89311 13.6844 4.35738C16.378 3.82165 19.1741 4.23647 21.5962 5.53117C24.0183 6.82587 25.9165 8.92035 26.9674 11.4577C28.0184 13.9951 28.157 16.8184 27.3597 19.4465C26.5624 22.0746 24.8785 24.345 22.595 25.8708C20.3114 27.3966 17.5694 28.0833 14.8362 27.8141C12.103 27.5448 9.54778 26.3362 7.60581 24.3942C6.50011 23.2944 5.6235 21.9862 5.02672 20.5453C4.42994 19.1045 4.12482 17.5595 4.12903 16ZM0 16C0 24.8387 7.16129 32 16 32C24.8387 32 32 24.8387 32 16C32 7.16129 24.8387 9.53674e-07 16 9.53674e-07C7.16129 9.53674e-07 0 7.16129 0 16Z",
    fill: "#698CA5"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8162_76654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "32",
    fill: "white",
    transform: "translate(0 32) rotate(-90)"
  })))));
});
var _default = exports.default = SteeringWheel;